import ScrollBar from "./ReactPerfectScrollbar";
export * from "./ReactPerfectScrollbar";
export default ScrollBar;